import {
  Component,
  ContentChild,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ModalContentDirective } from './directives/modal-content.directive';
import { ModalTriggerDirective } from './directives/modal-trigger.directive';

@Component({
  selector: 'black-ui-modal',
  templateUrl: './ui-modal.component.html',
  styleUrls: ['./ui-modal.component.css'],
  standalone: false,
})
export class UiModalComponent {
  @ContentChild(ModalContentDirective) modalContent:
    | ModalContentDirective
    | undefined;

  @ContentChild(ModalTriggerDirective) modalTrigger:
    | ModalTriggerDirective
    | undefined;

  isContentVisible = false;

  @ViewChild('content') contentRef: ViewContainerRef | undefined;

  toggleContent() {
    this.isContentVisible = !this.isContentVisible;
  }

  closeContent() {
    this.isContentVisible = false;
  }

  getCloseContent() {
    return this.closeContent.bind(this);
  }

  getToggleContent() {
    return this.toggleContent.bind(this);
  }
}
